<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/7jbDmN/media/FC-9781638295440.jpg?1693228932273" alt="This image is the cover for the book A Taste of Freedom"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">A Taste of Freedom
      </h1>
      <p class="bookDescription body article font2">
        <p>Doug Samuels is a highly respected but emotionally challenged ex-cop turned private investigator, who is reeling from a heartbreakingly painful loss. Working out of a small office in the St. Louis neighbourhood called Central West End, and with the assistance of his best friend’s wife, he receives little warning of his destiny.</p><p>Wittingly chosen for the task, Doug is hired by the spouse of a successful investment banker. The alarmingly sexy blond suspects the man she married of cheating and asks Doug to verify her suspicions. His pretty client entices and manipulates Doug’s vulnerabilities as a second case, involving an ex-pimp turned NFL running back, lures Doug back and forth across the country, forcing him to dodge and deflect warranted scrutiny from the FBI.</p><p>Accepting each case with the best of intentions, Doug’s professional ethics, and high moral standards are continuously challenged as he’s pulled deeper and deeper into a world of deception, lies, sex, and murder. Doug’s good nature paired with his inability to say no changes his life forever.</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Michael Kevin Reed
      </h2>
      
      <p class="authorDescription body article"><p>Michael Kevin Reed was born and raised in St. Louis, Missouri. Graduated from Lindenwood and Capella Universities, his passion for a great story and his fascination with the human condition led him to pursue writing and the creation of his first novel, <em>A Taste of Freedom</em>.</p></p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Austin Macauley Publishers
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?6bff9fd4